/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiFeedbacksIdMessagesMutationRequest, PostApiFeedbacksIdMessagesMutationResponse, PostApiFeedbacksIdMessagesPathParams, PostApiFeedbacksIdMessages400, PostApiFeedbacksIdMessages401, PostApiFeedbacksIdMessages403, PostApiFeedbacksIdMessages404, PostApiFeedbacksIdMessages500 } from "../../types/PostApiFeedbacksIdMessages.ts";
import { postApiFeedbacksIdMessagesMutationResponseSchema, postApiFeedbacksIdMessagesMutationRequestSchema } from "../../zod/FeedbackSchemas/postApiFeedbacksIdMessagesSchema.ts";

function getPostApiFeedbacksIdMessagesUrl({ id }: { id: PostApiFeedbacksIdMessagesPathParams["Id"] }) {
  const res = { method: 'POST', url: `/api/feedbacks/${id}/messages` as const }  
  return res
}

/**
 * @summary Создание сообщения
 * {@link /api/feedbacks/:Id/messages}
 */
export async function postApiFeedbacksIdMessages({ id, data }: { id: PostApiFeedbacksIdMessagesPathParams["Id"]; data?: PostApiFeedbacksIdMessagesMutationRequest }, config: Partial<RequestConfig<PostApiFeedbacksIdMessagesMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiFeedbacksIdMessagesMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiFeedbacksIdMessagesMutationResponse, ResponseErrorConfig<PostApiFeedbacksIdMessages400 | PostApiFeedbacksIdMessages401 | PostApiFeedbacksIdMessages403 | PostApiFeedbacksIdMessages404 | PostApiFeedbacksIdMessages500>, PostApiFeedbacksIdMessagesMutationRequest>({ method : "POST", url : getPostApiFeedbacksIdMessagesUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiFeedbacksIdMessagesMutationResponseSchema.parse(res.data)
}